import React from "react";
import { Box, Typography } from "@mui/material";
import theme from "../../theme";

interface Props {}

const Footer: React.FC<Props> = (props) => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          bottom: 0,
          width: "100%",
          paddingY: "2px",
          paddingX: 1,
          zIndex: (theme) => theme.zIndex.drawer - 1,
          height: "35px",
        }}
      >
        <Typography
          variant="caption"
          color="textPrimary"
          fontWeight="400"
          noWrap
          sx={{
            fontSize: { xs: "0.55rem", sm: "0.75rem" },
            position: "absolute",
            left: 8,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          COPYRIGHT {new Date().getFullYear()}
        </Typography>
        <Box
          component="img"
          height={120}
          src={"/static/images/SVPro.png"}
          alt="logo"
        />
      </Box>
    </>
  );
};

export default Footer;
